import{useEffect as e,useLayoutEffect as n}from"react";function o(o,r){return"undefined"==typeof window?e(o,r):n(o,r)}export{o as useIsomorphicLayoutEffect};
//# sourceMappingURL=use-isomorphic-layout-effect.js.map
